module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-ferris-wheel-88ceb984a76ee51535fb510964ceb9f2.svg";